import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  AdditionalDocumentsFormType,
  getAdditionalDocumentsSchema,
} from 'modules/client/common/forms/additionalDocumentsForm';
import {
  CompanyRegistrationAddressFormType,
  getCompanyRegistrationAddressSchema,
} from 'modules/client/common/forms/companyRegistrationAddressForm';
import {
  CompanyResidentialAddressFormType,
  companyResidentialAddressSchema,
} from 'modules/client/common/forms/companyResidentialAddressForm';
import {
  CompanyBaseStateRegistrationFormType,
  getCompanyBaseStateRegistrationSchema,
} from 'modules/client/common/forms/companyStateRegistrationForm';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import {
  CompanyTaxResidencyFormType,
  companyTaxResidencySchema,
} from './companyTaxResidencyForm';
import { ContactsFormType, getContactsSchema } from './contactsForm';
import {
  LegalClientBranchNameFormType,
  branchNameSchema,
} from './legalClientBranchNameForm';

export interface LegalClientBranchFormType
  extends ContactsFormType,
    LegalClientBranchNameFormType,
    CompanyTaxResidencyFormType,
    CompanyRegistrationAddressFormType,
    CompanyResidentialAddressFormType,
    CompanyBaseStateRegistrationFormType,
    AdditionalDocumentsFormType,
    ReasonChangeFormType {}

export const getSchema = (t: TFunc): ObjectSchema<LegalClientBranchFormType> =>
  object()
    .concat(getContactsSchema(t))
    .concat(companyTaxResidencySchema)
    .concat(getCompanyRegistrationAddressSchema())
    .concat(companyResidentialAddressSchema)
    .concat(branchNameSchema)
    .concat(reasonChangeSchema)
    .concat(getCompanyBaseStateRegistrationSchema(t))
    .concat(getAdditionalDocumentsSchema());

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientBranchFormType>();

export type FormErrors = FormErrorsBase<LegalClientBranchFormType>;
